var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import { Token } from '@/support/Token';
import { identifyApplication } from '@/support/Client';
import i18n from '@/i18n';
let Helps = class Helps extends Vue {
    constructor() {
        super(...arguments);
        this.token = '';
    }
    mounted() {
        this.token = Token.get();
    }
    get application() {
        return identifyApplication();
    }
    get language() {
        return i18n.locale;
    }
};
Helps = __decorate([
    Component({
    //
    })
], Helps);
export default Helps;
